@if (plantRequest) {
<div class="dialogContainer">
  <div class="dialogHeader">
    <img
      class="closeButton"
      src="/images/closeIconWithoutBox.png"
      (click)="closeDialog()"
    />
  </div>
  <div class="dialogContent">
    <app-dialog-input-title
      title="Navn"
      [required]="true"
    ></app-dialog-input-title>
    <input type="text" [(ngModel)]="plantRequest.plantName" />
    <app-dialog-input-title title="HWC Navn"></app-dialog-input-title>
    <input type="text" [(ngModel)]="plantRequest.hwpPlantName" />
    <app-dialog-input-title
      title="Kunde"
      [required]="true"
    ></app-dialog-input-title>
    <select [(ngModel)]="plantRequest.clientId">
        <option value="0" class="hidden">Vælg Kunde</option>
        @for (client of clients; track client.id) {
        <option [value]="client.id">
            {{ client.name }}
        </option>
        }
    </select>

    <app-dialog-input-title title="Projekt manager"></app-dialog-input-title>
    <select [(ngModel)]="plantRequest.projectManagerId">
        <option [ngValue]="null">(Ingen projektleder valgt)</option>
      @for (user of users; track user.id) {
      <option [value]="user.id">
        {{ user.name }}
      </option>
      }
    </select>
    <app-dialog-input-title title="Process ingeniør"></app-dialog-input-title>
    <select [(ngModel)]="plantRequest.processEngineerId">
        <option [ngValue]="null">(Ingen Process ingeniør valgt)</option>
        @for (user of users; track user.id) {
        <option [value]="user.id">
            {{ user.name }}
        </option>
        }
    </select>
    <app-dialog-input-title title="PLC ingeniør"></app-dialog-input-title>
    <select [(ngModel)]="plantRequest.plcEngineerId">
        <option [ngValue]="null">(Ingen PLC ingeniør valgt)</option>
        @for (user of users; track user.id) {
        <option [value]="user.id">
            {{ user.name }}
        </option>
        }
    </select>
  </div>
  <div class="dialogFooter">
    <app-save-button
      [disabled]="plantRequest.plantName == '' || plantRequest.clientId == 0"
      [clickEvent]="saveChanges.bind(this)"
    >
    </app-save-button>
    @if (userService.getSelectedRole == userService.getUserRoleTypes.Admin &&
    plantRequest.id != 0) {
    <app-delete-button [clickEvent]="deleteEntry.bind(this)">
    </app-delete-button>
    }
  </div>
</div>
}
